/* eslint-disable max-len */
export const tagsMessages = {
    'TagEditor.add_new_tag': 'Add a New Application Tag',
    'TagEditor.create_new_tag': 'Create Tag',
    'TagEditor.default_tag': 'Default Tag',
    'TagEditor.description':
        'Add new application tags or editing exiting ones.',
    'TagEditor.edit_tag': 'Edit Existing Application Tag',
    'TagEditor.tag': 'Tag',
    'TagEditor.title': 'Application Tag Editor',
    'Tags.active': 'Active',
    'Tags.adoptionMonitoring': 'Adoption Monitoring',
    'Tags.all': 'All',
    'Tags.cisCompliance': 'CIS Compliance',
    'Tags.color.option1': 'Cyan',
    'Tags.color.option2': 'Lavender',
    'Tags.color.option3': 'Orange',
    'Tags.color.option4': 'Green',
    'Tags.color.option5': 'Brown',
    'Tags.color.option6': 'Pink',
    'Tags.color.option7': 'Yellow',
    'Tags.color.option8': 'Sky Blue',
    'Tags.costOptimization': 'Cost Optimization',
    'Tags.deviceInventory': 'Device Inventory',
    'Tags.efficiency': 'Efficiency',
    'Tags.modals.delete.message':
        'Are you sure that you want to remove the tag?',
    'Tags.modals.delete.title': 'Delete tag',
    'Tags.modals.edit.title': 'Edit Tag {{name}}',
    'Tags.noNameTag': 'No {{name}} tag',
    'Tags.noTagsFound': 'No tags found',
    'Tags.research': 'Research',
    'Tags.riskManagement': 'Risk Management',
    'Tags.saasInventory': 'SaaS Inventory',
    'Tags.savings': 'Savings',
    'Tags.security': 'Security',
    'Tags.securityIncidents': 'Security Incidents',
    'Tags.table.title_one': 'tag',
    'Tags.table.title_other': 'tags',
    'Tags.trends': 'Trends',
    'Tags.underutilized': 'Underutilized',
    'Tags.undetected': 'Undetected',
    'Tags.unselected': 'No Tags Selected',
    'Tags.usageTrends': 'Usage Trends',
    'Tags.userManagement': 'User Management',
    'TagsForm.fields.name.placeholder': 'For example: Internal',
    'TagsForm.server.error':
        'Encountered an issue: Unable to save tag “{{name}}”.',
    'TagsForm.success': 'Tag “{{name}}” successfully saved.'
};
